/**
 * sessionOutcome — FW-console-entra-giris.
 *
 * GET /api/v1/auth/session Cosmos PERSONEL sözleşmesi yalnız kimlik ve rolleri
 * taşır: userId, email, name, roles (2026-09-22 kararı; EntraAuthEndpoints.cs,
 * CosmosPersonnelSessionResponse).
 * Cosmos veritabanı sabittir; müşteri tenant sözleşmesi bu DTO'ya ait değildir.
 * Console apps/auth'un
 * composable'ini DOGRUDAN import ETMEZ — her apps/* kendi domain/composables
 * agacini tasir (mevcut proje deseni, bkz. useAuthFlowState.ts'in Pinia
 * KULLANMAMA gerekcesi/"Brownfield clause" — frontend-vue skill).
 *
 * Console'a OZGU tek ek karar: System_Admin rolu. README.md ("console yuzeyi
 * tek admin/yonetim arayuzudur") ve gorev brief'i ("403 (rol yok — System_Admin
 * atanmamis olabilir)") bu rolu ACIKCA ister. Backend'in GET /api/v1/auth/session
 * ucu yalniz cerez dogrulamasi yapar (`RequireAuthorization`, ROL DEGIL) — yani
 * 200 dondugu HALDE `roles` System_Admin ICERMEYEBILIR. Bu durum kullaniciya
 * GERCEK bir 403 gibi (erisim yok) gosterilir ama backend'den olculen bir HTTP
 * 403 DEGIL, istemci tarafinda hesaplanir ('forbidden' sonucu). Backend ileride
 * bu uc icin GERCEKTEN 403 donerse (savunma amacli, asagida ayrica yakalanir)
 * o dal da AYNI 'forbidden' sonucuna eslenir — cagiran (guard/view) tek bir
 * durumu ele alir.
 *
 * Kasitli olarak SAF fonksiyon: `ApiClient` disaridan (main.ts'in
 * `createSurfaceApp()`'tan aldigi GERCEK istemci VEYA testin sahte istemcisi)
 * verilir, Vue'nin `inject()`'ine BAGLI DEGILDIR — boylece hem bilesen
 * agacinin icinde (useCurrentSession uzerinden) hem DISINDA (main.ts'teki
 * router guard, bkz. router/sessionGuard.ts) AYNI kod kullanilir ve mutasyonla
 * (bkz. sessionOutcome.spec.ts) kolayca kanitlanir.
 */
import { ApiError, type ApiClient } from '@fusapp-work/api'

export const SYSTEM_ADMIN_ROLE = 'System_Admin'

export interface SessionResponse {
  readonly userId: string
  readonly email: string | null
  readonly name: string | null
  readonly roles: readonly string[]
}

export type SessionOutcome =
  | { readonly kind: 'authenticated'; readonly session: SessionResponse }
  | { readonly kind: 'unauthenticated' }
  | { readonly kind: 'forbidden'; readonly session: SessionResponse | null }
  | { readonly kind: 'error'; readonly message: string }

export async function resolveSessionOutcome(apiClient: ApiClient): Promise<SessionOutcome> {
  try {
    const session = await apiClient.request<SessionResponse>('/api/v1/auth/session', { method: 'GET' })
    // Eksik veya yanlış tipte rol alanı yetki vermez; string.includes()
    // bir dizi kontrolü değildir ve bozuk bir DTO'yu yönetici yapmamalıdır.
    if (!Array.isArray(session.roles) || !session.roles.every((role) => typeof role === 'string')) {
      return { kind: 'forbidden', session: null }
    }
    if (!session.roles.includes(SYSTEM_ADMIN_ROLE)) {
      return { kind: 'forbidden', session }
    }
    return { kind: 'authenticated', session }
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) {
      return { kind: 'unauthenticated' }
    }
    if (error instanceof ApiError && error.status === 403) {
      return { kind: 'forbidden', session: null }
    }
    return { kind: 'error', message: error instanceof Error ? error.message : 'unknown error' }
  }
}
